import { useState, useEffect } from 'react';
import { fetchSolutions } from '../services/api';

/**
 * Custom hook to fetch all solutions from the API
 * @returns {Object} { solutions, loading, error }
 */
const useSolutions = () => {
  const [solutions, setSolutions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadSolutions = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await fetchSolutions();
        setSolutions(data);
      } catch (err) {
        console.error('Error loading solutions:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadSolutions();
  }, []);

  return { solutions, loading, error };
};

export default useSolutions;